/**
 * Current page status.
 */
export enum PageStatusFlags {
    Ready = 0,
    LoadingBot = 1,
    LoggingIn = 1 << 1,
    WaitingForBotReady = 1 << 2,
    WaitingForAppInsightsReady = 1 << 3,
    WaitingForWebChatToken = 1 << 4
}

/**
 * Page loading status.
 */
export interface IPageStatus {
    hasPageStatusFlag(flag: PageStatusFlags): boolean;
    isReady(): boolean;
}



// WEBPACK FOOTER //
// ./Client/v4/ComponentDataModels/IPageStatus.ts